import { makeStyles } from '@material-ui/core/styles';

export const reportIssueFormStyles = makeStyles(() => ({
  container: {
    backgroundColor: (props) => (props.mobile ? '' : '#F1F1F1'),
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: (props) => (props.mobile ? '' : '30px 70px'),
    borderTop: (props) => (props.mobile ? '' : '1px solid #6A148E'),
  },
  button: {
    width: 200,
    margin: '0 auto',
    marginBottom: (props) => (props.mobile ? 25 : 0),
  },
  loader: {
    height: 80,
    width: 80,
  },
}));
